import React, { useState, useEffect } from "react";
import { useSSR } from "@hooks/useSSR";
import * as c from "./previewBanner.module.scss";

const PREVIEW_HOSTS = ["mangomint-www.netlify.app"];

const PreviewBanner = () => {
  const [hidden, setHidden] = useState(false);
  const isSSR = useSSR();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.metaKey && e.key === ".") {
        setHidden((prev) => !prev);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  if (isSSR) return null;

  const hostname = window.location.hostname;
  const isPreview = PREVIEW_HOSTS.some((host) => hostname.includes(host));

  if (!isPreview) return null;

  return (
    <div
      className={c.banner}
      role="status"
      aria-label="Preview environment notice"
      style={hidden ? { visibility: "hidden", display: "none" } : undefined}
    >
      <span className={c.text}>
        Preview mode | Use <strong>CMD + .</strong> to toggle banner
      </span>
    </div>
  );
};

export default PreviewBanner;
